const scrollTop = () => {
  if ($(".scrollToTopBtn").length) {
    var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
    var rootElement = document.documentElement;

    function handleScroll() {
      var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
      if (rootElement.scrollTop / scrollTotal > 0.7) {
        scrollToTopBtn.classList.add("showBtn");
      } else {
        scrollToTopBtn.classList.remove("showBtn");
      }
    }

    function scrollToTop() {
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    scrollToTopBtn.addEventListener("click", scrollToTop);
    document.addEventListener("scroll", handleScroll);
  }

  

  if ($(".menu_fast_cat").length) {
        $('.menu_fast_cat .link_wrp a[href^="#"]').on('click', function (e) {
          e.preventDefault();

          var target = $(this).attr('href');
          var $target = $(target);

          if ($target.length) {
             // var offsetTop = $target.offset().top - 450;
             var catnav_height =  $('.menu_fast_cat').outerHeight()
             var offsetTop = $target.offset().top - $('.navbar-light').outerHeight() - catnav_height;

              $('html, body').animate(
                  { scrollTop: offsetTop },
                  600,
                  'swing'
              );
          }
      });
    }

  if ($(".scrollToDownBtn").length) {
          $('.btn_scroll_down').on('click', function (e) {
            const firstSection = document.querySelector('section');
            
            if (firstSection) {
                const offset = firstSection.getBoundingClientRect().top + window.scrollY - 160;
                
                window.scrollTo({
                    top: offset,
                    behavior: 'smooth'
                });
            }
        });
    }
};

export default scrollTop;
